import React from "react";

export default function SeriesSliderItem(props) {
  const series = props.series;

  let seriesFilters = props.filterGroups?.find((x) => x.id === "SeriesCodes")?.items;
  let matchingItem = seriesFilters?.find(x => x.text === series.code);

  function getArticleCountDynamically() {
    if (!!matchingItem && matchingItem?.count) {
      return matchingItem.count;
    }

    return series.articleCount;
  }

  function handleClick() {
    // if (matchingItem?.selected) {
    //   matchingItem.selected = false;
    // }

    props.onClick(series);
  }

  return (
    <>
      <label htmlFor={series.code} className="slideritem">
        <input
          type="radio"
          id={series.code}
          name={series.code}
          checked={series.selected && series.selected === true ? true : false}
          onClick={() => handleClick()}
          readOnly
        />

        <div className="c-series-card" >
          <div className="c-series-card__outer">
            <div className="c-series-card__inner">
              <i className="icon-check icon-lg"></i>
              <div className="c-series-card__image">
                <img src={i18n.CdnHostName + series.imageUrl + "?preset=c-series-list&width=170"} alt={series.name} />
              </div>
              {series.tags.length ? <div className="c-product-card__tag">{series.tags[0]}</div> : null}
              <h4 className="c-series-card__heading">
                <a href={"?code=" + series.code}>{series.name}</a>
              </h4>
              <p className="c-series-card__paragraph">
                {getArticleCountDynamically()} {i18n.getString("serieslisting.numberofarticles")}
              </p>
            </div>
          </div>
        </div>
        <div className="d-flex mt-3">
          <button className={props.seriesDataBtnActive ? 'c-button active' : "c-button"} onClick={() => props.showHideSeriesData(series)}>
            {i18n.getString("serieslisting.technicaldata")}
            <i className="icon-info-circle"></i>
          </button>
        </div>
      </label>
    </>
  );
}
